/**
 * Человеческое имя устройства по device_id.
 *
 * Возвращает короткую метку для таблиц и полное имя для подписей.
 * UUID/`phone-…` в UI не показываем — только `short`.
 */
export function deviceLabel(deviceId: string): { label: string; short: string } {
  if (deviceId.startsWith('phone-') || /^[0-9a-f]{8}-[0-9a-f]{4}/i.test(deviceId)) {
    const cleanId = deviceId.replace('phone-', '')
    return { label: '📱 Мобильная касса', short: cleanId.slice(0, 8) }
  }
  if (deviceId === 'pos-terminal-1' || /pos-terminal|main/i.test(deviceId)) {
    return { label: '💻 Стационарная касса', short: deviceId.slice(0, 8) }
  }
  return { label: `📟 ${deviceId}`, short: deviceId.slice(0, 8) }
}

/** Короткий идентификатор зоны/рабочего места — без полного UUID. */
export const shortId = (id: string | null | undefined): string => (id ?? '').slice(0, 8)
